/* eslint-disable react-hooks/exhaustive-deps */
import { withRouter } from "../_shared/withRouter";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import Header from "../template/_common/header";
import SidebarComponent from "../template/admin/sidebarComponent";
import SidebarArrow from "../template/_common/sidebarArrow";
import PaginationOwn from "../template/_common/ownPagination";
import { globalAlert, globalLoader } from "../actions/commonActions";
import { exportData, logOut } from "../_shared/commonFunction";
import { lmsListNewsletterApi } from "./_lmsActions";

const rowId = (r) => r?._id || r?.id;
const fullName = (r) =>
  `${r?.firstName || ""} ${r?.lastName || ""}`.trim() || "-";

const formatDate = (value) => {
  if (!value) return "-";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "-";
  return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
};
const csvCell = (value) => {
  const text = value == null ? "" : String(value);
  if (text.startsWith('="') && text.endsWith('"')) {
    return text;
  }
  return `"${text.replace(/"/g, '""')}"`;
};

const LmsNewsletter = (props) => {
  const { t } = useTranslation();
  const [navbarToggle, setNavbarToggle] = useState(false);
  const [allowView, setAllowView] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [counts, setCounts] = useState({});
  const [searchValue, setSearchValue] = useState("");
  const [subscribedFilter, setSubscribedFilter] = useState("all"); // all | subscribed | unsubscribed
  const [pageSize, setPageSize] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    callBasicApi();
  }, [currentPage, pageSize, subscribedFilter]);

  const callBasicApi = async (
    page = currentPage,
    search = searchValue,
    sub = subscribedFilter
  ) => {
    try {
      globalLoader(true);
      const params = new URLSearchParams({ page: String(page), limit: String(pageSize) });
      if (search.trim()) params.set("search", search.trim());
      // Documented filter: subscribed=true|false (omit for all).
      if (sub === "subscribed") params.set("subscribed", "true");
      else if (sub === "unsubscribed") params.set("subscribed", "false");
      const res = await lmsListNewsletterApi(`?${params.toString()}`);
      if (res?.data?.status === 200) {
        const data = res?.data?.data || {};
        setDataList(data?.list || []);
        setCounts(data?.counts || {});
        setTotalCount(data?.pagination?.total ?? (data?.list || []).length);
        setAllowView(true);
      } else {
        globalAlert("error", res?.data?.message);
      }
      globalLoader(false);
    } catch (error) {
      globalLoader(false);
      globalAlert("error", error?.response?.data?.message);
      if (error?.response?.data?.status === 401) logOut(props?.history, "/admin/login");
    }
  };

  const searchFilter = (ev) => {
    ev.preventDefault();
    if (currentPage !== 1) setCurrentPage(1);
    else callBasicApi(1);
  };

  const clearSearch = () => {
    setSearchValue("");
    setSubscribedFilter("all");
    if (currentPage !== 1) setCurrentPage(1);
    else callBasicApi(1, "", "all");
  };

  const selectFilter = (value) => {
    setSubscribedFilter(value);
    if (currentPage !== 1) setCurrentPage(1);
  };

  const goToPageFunc = (val, data) => {
    if (data === "prev" && currentPage > 1) setCurrentPage(currentPage - 1);
    else if (data === "next" && currentPage < Math.ceil(totalCount / pageSize))
      setCurrentPage(currentPage + 1);
    else if (val?.target?.value) setCurrentPage(Number(val.target.value));
  };

  const exportFilteredNewsletter = async () => {
    try {
      globalLoader(true);
      const params = new URLSearchParams({
        page: "1",
        limit: String(Math.max(totalCount || pageSize, pageSize, 1000)),
      });
      if (searchValue.trim()) params.set("search", searchValue.trim());
      if (subscribedFilter === "subscribed") params.set("subscribed", "true");
      else if (subscribedFilter === "unsubscribed") params.set("subscribed", "false");

      const res = await lmsListNewsletterApi(`?${params.toString()}`);
      const data = res?.data?.data || {};
      const rows = data?.list || [];
      if (res?.data?.status !== 200) {
        globalAlert("error", res?.data?.message);
        globalLoader(false);
        return;
      }
      if (!rows.length) {
        globalAlert("warning", "No subscribers available for the selected filters.");
        globalLoader(false);
        return;
      }

      const headers = ["Name", "Email", "Status", "Source", "Subscribed on"];
      const csvRows = rows.map((row) => [
        fullName(row),
        row?.email || "-",
        row?.isSubscribed !== false ? "Subscribed" : "Unsubscribed",
        row?.source || "-",
        `="${formatDate(row?.subscribedAt || row?.createdAt)}"`,
      ]);
      const csv = [headers, ...csvRows]
        .map((row) => row.map(csvCell).join(","))
        .join("\r\n");
      exportData(
        `\uFEFF${csv}`,
        `newsletter-subscribers-${new Date().getTime()}.csv`,
        "text/csv;charset=utf-8;"
      );
      globalLoader(false);
    } catch (error) {
      globalLoader(false);
      globalAlert("error", error?.response?.data?.message);
    }
  };

  return (
    <>
      <Helmet>
        <title>{t("admin.lms.newsletter.title", "Newsletter subscribers")} - eC-Card</title>
        <meta name="viewport" content="width=1200, initial-scale=1" />
      </Helmet>
      {allowView && (
        <div className="admin-portal">
          <Header roleType="admin" />
          <div className={`${navbarToggle ? "active" : ""} wrapper`}>
            <SidebarComponent navbarToggle={navbarToggle} roleType="admin" menu="lms" subMenu="lms-newsletter" />
            <div className="main">
              <div className="main-wrapper">
                <p className="admin-banner">{t("admin.lms.newsletter.title", "Newsletter subscribers")}</p>
                <SidebarArrow handleSidebarToggle={setNavbarToggle} />

                <div className="container-fluid pt-3 lms-learners-page lms-newsletter-page">
                  <div className="lms-learners-heading">
                    <div>
                      <h1>{t("admin.lms.newsletter.title", "Newsletter subscribers")}</h1>
                      <p>{t("admin.lms.newsletter.subtitle", "People subscribed to your organisation's newsletter.")}</p>
                    </div>
                    <button type="button" className="btn secondary-btn lms-newsletter-export-btn" onClick={exportFilteredNewsletter}>
                      <i className="fas fa-file-csv"></i> Export CSV
                    </button>
                  </div>

                  <div className="lms-newsletter-stats">
                    <span className="lms-newsletter-stat">
                      <strong>{counts?.subscribed ?? 0}</strong>
                      {t("admin.lms.newsletter.statusSubscribed", "Subscribed")}
                    </span>
                    <span className="lms-newsletter-stat">
                      <strong>{totalCount}</strong>
                      {t("admin.lms.newsletter.totalLabel", "Total")}
                    </span>
                  </div>

                  <form className="lms-learner-filters" onSubmit={searchFilter}>
                    <div className="lms-learner-search">
                      <i className="fas fa-search"></i>
                      <input
                        className="form-control"
                        placeholder={t("admin.lms.newsletter.searchPlaceholder", "Search name or email...")}
                        value={searchValue}
                        onChange={(e) => setSearchValue(e.target.value)}
                      />
                    </div>
                    <div className="lms-filter-select">
                      <i className="fas fa-envelope lms-filter-select-icon" aria-hidden="true"></i>
                      <select
                        aria-label={t("admin.lms.newsletter.colStatus", "Status")}
                        className="form-control"
                        value={subscribedFilter}
                        onChange={(e) => selectFilter(e.target.value)}
                      >
                        <option value="all">{t("admin.lms.newsletter.filterAll", "All subscribers")}</option>
                        <option value="subscribed">{t("admin.lms.newsletter.statusSubscribed", "Subscribed")}</option>
                        <option value="unsubscribed">{t("admin.lms.newsletter.statusUnsubscribed", "Unsubscribed")}</option>
                      </select>
                      <i className="fas fa-chevron-down lms-filter-select-arrow" aria-hidden="true"></i>
                    </div>
                    <div className="lms-filter-actions">
                      <button type="submit" className="btn secondary-btn lms-filter-apply">
                        <i className="fas fa-filter"></i> {t("common.apply", "Apply")}
                      </button>
                      <button type="button" className="btn lms-filter-reset" onClick={clearSearch}>
                        <i className="fas fa-undo-alt"></i> {t("common.reset", "Reset")}
                      </button>
                    </div>
                  </form>

                  <div className="lms-learner-list-card">
                    {dataList.length > 0 ? (
                      <div className="table-responsive">
                        <table className="table table-hover lms-learner-table">
                          <thead>
                            <tr>
                              <th>{t("admin.lms.newsletter.colName", "Name")}</th>
                              <th>{t("admin.lms.newsletter.colEmail", "Email")}</th>
                              <th>{t("admin.lms.newsletter.colStatus", "Status")}</th>
                              <th>{t("admin.lms.newsletter.colSource", "Source")}</th>
                              <th>{t("admin.lms.newsletter.colSubscribed", "Subscribed on")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {dataList.map((row, index) => {
                              const subscribed = row?.isSubscribed !== false;
                              return (
                                <tr key={rowId(row) || index}>
                                  <td><strong>{fullName(row)}</strong></td>
                                  <td>{row?.email || "-"}</td>
                                  <td>
                                    <span className={`lms-badge ${subscribed ? "badge-green" : "badge-gray"}`}>
                                      {subscribed
                                        ? t("admin.lms.newsletter.statusSubscribed", "Subscribed")
                                        : t("admin.lms.newsletter.statusUnsubscribed", "Unsubscribed")}
                                    </span>
                                  </td>
                                  <td className="text-capitalize">{row?.source || "-"}</td>
                                  <td>{formatDate(row?.subscribedAt || row?.createdAt)}</td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <div className="lms-learner-empty">
                        <i className="fas fa-envelope-open-text"></i>
                        <strong>{t("admin.lms.newsletter.empty", "No subscribers yet.")}</strong>
                        <p>{t("admin.lms.newsletter.emptyHint", "Add a subscriber, or people who opt in during registration will appear here.")}</p>
                      </div>
                    )}
                  </div>

                  {dataList.length > 0 && (
                    <div className="lms-learner-pagination">
                      <PaginationOwn
                        pageSize={pageSize}
                        changePageSize={(event) => { setPageSize(event.target.value); setCurrentPage(1); }}
                        goToPage={goToPageFunc}
                        totalCount={totalCount}
                        currentPage={currentPage}
                        applicationType="subscribers"
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default withRouter(LmsNewsletter);
